import {
    JWT
}
from "../../../../constants/local-storage";


//========================================================
// Eva Speech Service
//
// Requests PCM16 speech audio from the OmniScan backend.
//========================================================


//========================================================
// Generate Speech
//========================================================

export async function generateSpeech(
    text
)
{

    //----------------------------------------------------
    // Validate Text
    //----------------------------------------------------

    if (
        !text ||
        !text.trim()
    )
    {

        throw new Error(
            "Speech text must not be empty."
        );

    }


    //----------------------------------------------------
    // Call OmniScan Backend
    //----------------------------------------------------

    const response =
        await fetch(
            "/resolutionsoftwareplatform/eva/speech",
            {
                method:
                    "POST",

                headers:
                {
                    "Authorization":
                        localStorage.getItem(
                            JWT
                        ),

                    "Accept":
                        "application/octet-stream",

                    "Content-Type":
                        "application/json"
                },

                body:
                    JSON.stringify(
                        {
                            text:
                                text
                        }
                    )
            }
        );


    //----------------------------------------------------
    // Validate Response
    //----------------------------------------------------

    if (!response.ok)
    {

        throw new Error(
            "Unable to generate Eva speech: "
            + response.status
        );

    }


    //----------------------------------------------------
    // Read PCM Audio
    //----------------------------------------------------

    const audioBuffer =
        await response.arrayBuffer();


    //----------------------------------------------------
    // Return Audio Bytes
    //----------------------------------------------------

    return new Uint8Array(
        audioBuffer
    );

}